import React, { useState } from "react";

interface Props {
  suggestion: string;
  isStreaming?: boolean;
  onFeedback?: (useful: boolean) => void;
}

export function SuggestionCard({ suggestion, isStreaming, onFeedback }: Props) {
  const [feedback, setFeedback] = useState<boolean | null>(null);

  const handleFeedback = (useful: boolean) => {
    setFeedback(useful);
    onFeedback?.(useful);
  };

  return (
    <div style={{
      background: "rgba(8, 8, 12, 0.55)",
      backdropFilter: "blur(24px) saturate(180%)",
      WebkitBackdropFilter: "blur(24px) saturate(180%)",
      border: "1px solid rgba(255,255,255,0.06)",
      borderRadius: "14px",
      padding: "14px 16px",
      color: "rgba(255,255,255,0.92)",
      fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui, sans-serif",
      fontSize: "13px",
      lineHeight: "1.65",
      width: "100%",
      boxShadow: "0 8px 32px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.04)",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 10 }}>
        <div style={{
          width: 18, height: 18, borderRadius: 6,
          background: "linear-gradient(135deg, rgba(139,92,246,0.9), rgba(99,102,241,0.9))",
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: 9, color: "rgba(255,255,255,0.95)",
          flexShrink: 0,
        }}>
          {isStreaming ? <SpinDot /> : "✦"}
        </div>
        <span style={{
          fontSize: 10, color: "rgba(255,255,255,0.35)",
          textTransform: "uppercase", letterSpacing: "0.08em", fontWeight: 600,
        }}>
          {isStreaming ? "Thinking…" : "Evyely"}
        </span>
        {isStreaming && (
          <div style={{
            width: 5, height: 5, borderRadius: "50%",
            background: "#22c55e",
            boxShadow: "0 0 8px #22c55e",
            marginLeft: "auto",
            animation: "evPulse 1.2s ease-in-out infinite",
          }} />
        )}
      </div>

      <div style={{ whiteSpace: "pre-wrap", color: "rgba(255,255,255,0.88)", fontSize: 13, lineHeight: 1.65 }}>
        {suggestion}
        {isStreaming && <span style={{ opacity: 0.5, marginLeft: 1 }}>▌</span>}
      </div>

      {!isStreaming && suggestion && feedback === null && (
        <div style={{ display: "flex", gap: 6, marginTop: 12 }}>
          <button
            onClick={() => handleFeedback(true)}
            style={{
              background: "rgba(34,197,94,0.12)",
              border: "1px solid rgba(34,197,94,0.2)",
              color: "rgba(34,197,94,0.8)",
              borderRadius: 7,
              padding: "3px 10px",
              fontSize: 11,
              cursor: "pointer",
              fontWeight: 500,
            }}
          >
            👍
          </button>
          <button
            onClick={() => handleFeedback(false)}
            style={{
              background: "rgba(239,68,68,0.1)",
              border: "1px solid rgba(239,68,68,0.18)",
              color: "rgba(239,68,68,0.75)",
              borderRadius: 7,
              padding: "3px 10px",
              fontSize: 11,
              cursor: "pointer",
              fontWeight: 500,
            }}
          >
            👎
          </button>
        </div>
      )}

      {feedback !== null && (
        <div style={{ marginTop: 10, fontSize: 11, color: "rgba(255,255,255,0.3)" }}>
          {feedback ? "Noted ✓" : "Got it"}
        </div>
      )}

      <style>{`
        @keyframes evPulse { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:0.4;transform:scale(0.85)} }
        @keyframes evSpin { 0%{transform:rotate(0deg)} 100%{transform:rotate(360deg)} }
      `}</style>
    </div>
  );
}

function SpinDot() {
  return (
    <div style={{
      width: 8, height: 8, borderRadius: "50%",
      border: "1.5px solid rgba(255,255,255,0.6)",
      borderTopColor: "transparent",
      animation: "evSpin 0.7s linear infinite",
    }} />
  );
}
